import React, { useEffect, useState } from "react";
import './../Stripe.css'
import {
  PaymentElement,
  usePaymentClient,
  usePaymentElements
} from "../payments";
// import { useHistory } from "react-router-dom";

export default function CheckoutForm(props) {
  const stripe = usePaymentClient();
  const elements = usePaymentElements();
  // const history = useHistory();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [return_url, setReturnUrl] = useState(`${window.location.origin}/quickpaysubmitted?failed`);

  let [isCardPay, setIsCardPay] = useState(true);
  let [fullName, setFullName] = useState('');
  let [email, setEmail] = useState('');

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = props.clientSecret;

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
        setReturnUrl(`${window.location.origin}/quickpaysubmitted?amount=${paymentIntent.amount}`);
      if (paymentIntent.status === 'failed') {
        setReturnUrl(`${window.location.origin}/quickpaysubmitted?failed=true`);
      }
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    let { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: return_url,
      },
    });

    if (error && (error.type === "card_error" || error.type === "validation_error")) {
      setMessage(error.message);
    } else if (error) {
      setMessage("An unexpected error occured.");
    }

    setIsLoading(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" className={!isCardPay && 'display-none'} />
      <button disabled={isLoading || !stripe || !elements} id="submit">
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
        </span>
      </button>
      {message && <div className='errors-stripe' id="payment-message">{message}</div>}
    </form>
  );
}
